'use strict';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ContaParcelaService } from '../shared/conta-parcela.service';

import { InfoDialogComponent } from '../../core/dialogs/info-dialog/info-dialog.component';

import { ContaParcela } from '../shared/conta-parcela.model';
import { ContaService } from '../shared/conta.service';
import { OperacaoContabilService } from '../../contabil/shared/operacao-contabil.service';
import { Anexo } from 'src/app/anexo/shared/anexo.model';
import { AnexoService } from 'src/app/anexo/shared/anexo.service';
import { ContaCorrenteTerminalService } from 'src/app/conta-corrente/shared/conta-corrente-terminal.service';
import * as moment from 'moment';
import { AdquirenciaService } from 'src/app/conta-corrente/shared/adquirencia.service';
import { CaixaService } from '../shared/caixa.service';

export interface DialogData {
  contaParcelaId: number,
  parcelasSugeridas: number,
}

@Component({
  selector: 'conta-parcela-baixa',
  templateUrl: 'conta-parcela-baixa.component.html',
  styleUrls: ['conta-parcela-baixa.css'],
})

export class ContaParcelaBaixaComponent {

  @ViewChild('arquivoInput', { static: true }) arquivoInput;
  diasAtraso: number = 0;
  contaParcelaBaixaForm: FormGroup;
  maximizado: boolean;
  adiantamentos: any = [];
  operacoesContabeis: any = [];
  caixas: any = [];
  arquivo: any = {
    contaCorrenteId: 0,
    nomeArquivo: '',
    corpoArquivo: ''
  };
  anexo: Anexo = new Anexo();
  contaCorrenteTerminais: any = [];
  contaCorrenteTerminalCartoes: any = [];
  selectContaCorrenteTerminal: any = {};
  contaCorrenteAdquirencias: any = [];
  quantidadeParcelasCartao: number = 1;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ContaParcelaBaixaComponent>,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public IContaParcelaBaixa: DialogData,
    private contaParcelaService: ContaParcelaService,
    private contaService: ContaService,
    private operacaoContabilService: OperacaoContabilService,
    private contaCorrenteTerminalService: ContaCorrenteTerminalService,
    private anexoService: AnexoService,
    private adquirenciaService: AdquirenciaService,
    private caixaService: CaixaService) {
  }

  ngOnInit() {

    this.maximizado = false;

    this.contaParcelaBaixaForm = this._formBuilder.group(new ContaParcela);

    this.contaParcelaBaixaForm.addControl('comjuros', new FormControl(false));
    this.contaParcelaBaixaForm.addControl('liquidar', new FormControl(true));
    this.contaParcelaBaixaForm.addControl('comdesconto', new FormControl(false));

    const valorPagamento = this.contaParcelaBaixaForm.get('valorPagamento');
    valorPagamento.setValidators([Validators.required]);
    valorPagamento.updateValueAndValidity({ emitEvent: false });

    this.onChanges();

    if (this.IContaParcelaBaixa.contaParcelaId > 0) {

      this.contaParcelaService.getContaParcela(this.IContaParcelaBaixa.contaParcelaId).subscribe(data => {
        const contaParcela = data.body;

        contaParcela.dataPagamento = new Date();
        this.contaParcelaBaixaForm.patchValue(contaParcela, { emitEvent: false });
        this.contaParcelaBaixaForm.patchValue({
          statusPagamento: 1,
          valorAteVenc: contaParcela.valorParcela,
          caixaId: contaParcela.caixaId
        }, { emitEvent: false });
        this.buscarCaixas();
        this.buscarAdquirencias();

        const valorParcela = this.numeroOuZero(this.contaParcelaBaixaForm.get('valorParcela').value);
        const dataVencimento = new Date(contaParcela.dataVencimento);
        if (dataVencimento < contaParcela.dataPagamento && contaParcela.tipoConta == 0) {
          this.contaParcelaService.getContaCorrente(this.IContaParcelaBaixa.contaParcelaId).subscribe(data2 => {
            const contaCorrente = data2.body;
            const diasEmAtraso = moment(new Date()).diff(moment(dataVencimento), 'days');
            const valorParcelaComDesconto = valorParcela - this.numeroOuZero(
              this.contaParcelaBaixaForm.get('valorDescontoPago').value);

            if (diasEmAtraso > 0) {
              switch (contaCorrente?.tipoMulta) {
                case 1: // Valor fixo
                  contaParcela.valorMultaPago = this.arredondar(contaCorrente.valorMulta);
                  break;
                case 2: // Valor percentual
                  contaParcela.valorMultaPago = this.arredondar(
                    contaCorrente.valorMulta * valorParcelaComDesconto / 100);
                  break;
                default:
                  contaParcela.valorMultaPago = 0;
                  break;
              }

              switch (contaCorrente?.tipoJuros) {
                case 5: // Sem juros
                  contaParcela.valorJurosPago = 0;
                  break;
                case 90: // Percentual mensal
                case 91: // Percentual diário
                case 92: // Percentual anual
                  contaParcela.valorJurosPago = this.arredondar(
                    (contaCorrente.valorJuros * diasEmAtraso * valorParcela) / 100);
                  break;
                case 93: // Valor diário
                  contaParcela.valorJurosPago = this.arredondar(contaCorrente.valorJuros * diasEmAtraso);
                  break;
                default:
                  contaParcela.valorJurosPago = 0;
                  break;
              }
            } else {
              contaParcela.valorMultaPago = 0;
              contaParcela.valorJurosPago = 0;
            }

            this.diasAtraso = diasEmAtraso;
            this.contaParcelaBaixaForm.patchValue({
              valorMultaPago: this.numeroOuZero(contaParcela.valorMultaPago),
              valorJurosPago: this.numeroOuZero(contaParcela.valorJurosPago),
              comjuros: true
            }, { emitEvent: false });
            this.calcularValorPagamento(valorParcela);
          });
        } else {
          this.calcularValorPagamento(valorParcela);
        }
      });
    }

    this.restaurarDialog();

  }

  onChanges(): void {

    this.contaParcelaBaixaForm
      .get('comjuros')
      .valueChanges
      .subscribe(() => {
        this.calcularValorPagamento(this.contaParcelaBaixaForm.get('valorParcela').value);
      });

      this.contaParcelaBaixaForm
      .get('valorJurosPago')
      .valueChanges
      .subscribe(data => {

        this.calcularValorPagamento(this.contaParcelaBaixaForm.get('valorParcela').value);
      });

      this.contaParcelaBaixaForm
      .get('valorDescontoPago')
      .valueChanges
      .subscribe(data => {

        this.calcularValorPagamento(this.contaParcelaBaixaForm.get('valorParcela').value);
      });


      this.contaParcelaBaixaForm
      .get('valorMultaPago')
      .valueChanges
      .subscribe(data => {

        this.calcularValorPagamento(this.contaParcelaBaixaForm.get('valorParcela').value);
      });


    this.contaParcelaBaixaForm
      .get('tipoPagamento')
      .valueChanges
      .subscribe(data => {

        switch (data) {

          case 8:

            this.contaParcelaBaixaForm.get('contaParcelaTipo').setValue(2);

            this.contaService.getAdiantamentoPorContaId(this.contaParcelaBaixaForm.value.contaId).subscribe(data => {

              this.adiantamentos = data.body;

            }, (error: HttpErrorResponse) => {

              const dialogRef = this.dialog.open(InfoDialogComponent, {
                data: {
                  titulo: "Erro",
                  erro: error
                }
              });
            });

            this.operacaoContabilService.getOperacoesContabeis().subscribe(data => {

              this.operacoesContabeis = data.body;

            }, (error: HttpErrorResponse) => {

              const dialogRef = this.dialog.open(InfoDialogComponent, {
                data: {
                  titulo: "Erro",
                  erro: error
                }
              });
            });

            break;

          case 1:
          case 2:
            this.contaParcelaBaixaForm.get('contaParcelaTipo').setValue(this.contaParcelaBaixaForm.value.tipoConta);
            break;

          default:
            this.contaParcelaBaixaForm.get('contaParcelaTipo').setValue(this.contaParcelaBaixaForm.value.tipoConta);

            break;

        }
      });

    this.contaParcelaBaixaForm
      .get('caixaId')
      .valueChanges
      .subscribe(data => {

        // busca adquirencias vinculadas a conta corrente da parcela
        this.buscarAdquirencias();

      });

  }

  //calcular valor do pagamento
  calcularValorPagamento(valor:number) {

    const valorParcela = this.numeroOuZero(valor);
    const comJuros = this.contaParcelaBaixaForm.get('comjuros').value === true;
    const valorMulta = comJuros ? this.numeroOuZero(
      this.contaParcelaBaixaForm.get('valorMultaPago').value) : 0;
    const valorJuros = comJuros ? this.numeroOuZero(
      this.contaParcelaBaixaForm.get('valorJurosPago').value) : 0;
    const valorDesconto = this.numeroOuZero(
      this.contaParcelaBaixaForm.get('valorDescontoPago').value);
    const valorPagamento = this.arredondar((valorParcela - valorDesconto) + valorMulta + valorJuros);

    this.contaParcelaBaixaForm.get('valorPagamento').setValue(valorPagamento);

  }

  private arredondar(valor: number): number {
    return Math.round((valor + Number.EPSILON) * 100) / 100;
  }

  private numeroOuZero(valor: any): number {
    const numero = Number(valor);

    return Number.isFinite(numero) ? numero : 0;
  }

  buscarCaixas() {

    this.contaService.getCaixas(this.contaParcelaBaixaForm.value.tipoConta).subscribe(data => {

      this.caixas = data.body;

    });
  }

  fecharDialog(statusPagamento: number) {
    this.dialogRef.close(statusPagamento);
  }

  maximizarDialog() {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog() {

    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('90%', '100vh');
    }
    else {
      this.dialogRef.updateSize('60%', '100vh');
    }
    this.maximizado = false;
  }

  salvar(): void {

    if (this.contaParcelaBaixaForm.value.tipoPagamento == 2 && this.contaParcelaBaixaForm.value.tipoConta == 0) {

      if (this.contaParcelaBaixaForm.value.contaCorrenteTerminalCartaoId < 1) {

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: "Erro",
            mensagem: "Para pagamento no cartão de crédito é obrigatório selecionar um cartão"
          }
        });

        return;

      }

      if (this.contaParcelaBaixaForm.value.numeroParcelas < 1) {

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: "Erro",
            mensagem: "Para pagamento no cartão de crédito é obrigatório selecionar um número de parcelas maior que zero"
          }
        });

        return;

      }

      if (this.contaParcelaBaixaForm.value.codigoAutenticacao.length == 0) {

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: "Erro",
            mensagem: "Para pagamento no cartão de crédito é obrigatório preencher o código de autenticação do comprovante de pagamento"
          }
        });

        return;
      }


    }

    if (this.contaParcelaBaixaForm.value.liquidar == false) {

      if (this.contaParcelaBaixaForm.value.valorQueFicaraAtivo == 0) {

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: "Erro",
            mensagem: "É necessário preencher o valor que ficará ativo se não for liquidar integralmente"
          }
        });

        return;

      }

    }

    const dadosBaixa = {
      ...this.contaParcelaBaixaForm.value,
      valorJurosPago: this.contaParcelaBaixaForm.value.comjuros
        ? this.numeroOuZero(this.contaParcelaBaixaForm.value.valorJurosPago) : 0,
      valorMultaPago: this.contaParcelaBaixaForm.value.comjuros
        ? this.numeroOuZero(this.contaParcelaBaixaForm.value.valorMultaPago) : 0
    };

    this.contaParcelaService.putContaParcela(dadosBaixa.contaParcelaId, dadosBaixa).subscribe(data => {

      this.uploadArquivo();

      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: "Sucesso",
          mensagem: "Baixa realizada"
        }
      });

      this.fecharDialog(this.contaParcelaBaixaForm.value.statusPagamento);

    });

  }

  uploadArquivo() {


    if (this.anexo.nomeArquivo.length > 0) {

      let formData = new FormData();
      formData.append('fileUpload', this.arquivoInput.nativeElement.files[0]);
      formData.append('descricao', this.anexo.descricao);
      formData.append('documentoIdReferenciado', this.anexo.documentoIdReferenciado.toString());
      formData.append('documentoTipo', this.anexo.documentoTipo.toString());
      formData.append('nomeArquivo', this.anexo.nomeArquivo);
      formData.append('saguiClienteId', this.anexo.saguiClienteId.toString());

      this.anexoService.postAnexo(formData).subscribe(data => {


      });
    }
  }

  fileChanged(e: any) {

    this.anexo.descricao = "Comprovante de Pagamento";
    this.anexo.nomeArquivo = e.target.files[0].name;

    if(this.contaParcelaBaixaForm.get("contaParcelaTipo").value === 0){
      this.anexo.documentoTipo = 10;
    } else{
      this.anexo.documentoTipo = 11;
    }

    this.anexo.documentoIdReferenciado = this.contaParcelaBaixaForm.value.contaParcelaId;
    this.anexo.saguiClienteId = this.contaParcelaBaixaForm.value.saguiClienteId;
    this.anexo.corpoArquivo = e.target.files[0];

    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      this.anexo.corpoArquivo = fileReader.result;
    }

    fileReader.readAsDataURL(e.target.files[0]);

  }


  buscarContaCorrenteTerminaisPorAdquirencia(adquirenciaId: number) {
    this.contaCorrenteTerminalService.getPorAdquirenciaId(adquirenciaId).subscribe(data => {

      this.contaCorrenteTerminais = data.body;

      if (this.contaCorrenteTerminais.length > 0) {

        this.selectContaCorrenteTerminal = this.contaCorrenteTerminais[0];

        this.defineContaCorrenteTerminal(this.contaCorrenteTerminais[0]);
      } else {

        this.contaCorrenteTerminalCartoes = [];
        this.contaParcelaBaixaForm.get('contaCorrenteTerminalCartaoId').setValue(0);
        this.contaParcelaBaixaForm.get('numeroParcelas').setValue(0);
        this.quantidadeParcelasCartao = 0;
      }

    });

  }

  defineContaCorrenteTerminal(contaCorrenteTerminal) {

    this.contaParcelaBaixaForm.get('contaCorrenteTerminalId').setValue(contaCorrenteTerminal.contaCorrenteTerminalId);

    this.contaCorrenteTerminalCartoes = contaCorrenteTerminal.contaCorrenteTerminalCartoes;

    if (this.contaCorrenteTerminalCartoes != null && this.contaCorrenteTerminalCartoes.length > 0) {
      this.contaParcelaBaixaForm.get('contaCorrenteTerminalCartaoId').setValue(this.contaCorrenteTerminalCartoes[0].contaCorrenteTerminalCartaoId);
    }else{
      this.contaParcelaBaixaForm.get('contaCorrenteTerminalCartaoId').setValue(0);
      this.quantidadeParcelasCartao = 0;
    }

  }

  atualizarValorAPagar(valorQueFicaraAtivo: number){

    let valorParcela = this.contaParcelaBaixaForm.get('valorParcela').value;

    let valorPagamentoAposCalculo = valorParcela - valorQueFicaraAtivo;

    this.calcularValorPagamento(valorPagamentoAposCalculo);

  }

  buscarAdquirencias() {
    // obtem contaCorrente realcionada ao caixa selecionado
    let caixaIdSelecionado = this.contaParcelaBaixaForm.get('caixaId').value;

    this.caixaService.getCaixa(caixaIdSelecionado).subscribe(data => {
      let caixaRelacionada = data.body;

      // se não houver limpa lista de adquirencias e selecao
      if (!caixaRelacionada.contaCorrenteId) {
        this.contaCorrenteAdquirencias = [];
        this.contaParcelaBaixaForm.get('adquirenciaId')?.setValue(0);
        this.selectContaCorrenteTerminal = {};
        this.contaCorrenteTerminais = [];
        this.contaParcelaBaixaForm.get('contaCorrenteTerminalId').setValue(0);
        this.contaCorrenteTerminalCartoes = [];

        return;

      // se houver busca adquirencias vinculadas
      }else{

        this.adquirenciaService
          .getAdquirenciasPorContaCorrenteId(caixaRelacionada.contaCorrenteId)
          .subscribe({
            next: (data) => {
              this.contaCorrenteAdquirencias =
                data.body.filter(item => item.ativo === true);

                // se tiver apenas uma adquirência, seleciona ela automaticamente
                if (this.contaCorrenteAdquirencias.length > 0) {
                   const adquirenciaId = this.contaCorrenteAdquirencias[0].adquirenciaId;

                    this.contaParcelaBaixaForm.get('adquirenciaId')?.setValue(adquirenciaId);

                  this.buscarContaCorrenteTerminaisPorAdquirencia(adquirenciaId);
                } else {
                  // limpa seleção se não tiver adquirência
                  this.contaCorrenteAdquirencias = [];
                  this.contaParcelaBaixaForm.get('adquirenciaId')?.setValue(0);
                  this.selectContaCorrenteTerminal = {};
                  this.contaCorrenteTerminais = [];
                  this.contaParcelaBaixaForm.get('contaCorrenteTerminalId').setValue(0);
                  this.contaCorrenteTerminalCartoes = [];
                }
            },
            error: () => {
              this._snackBar.open(
                'Erro ao buscar adquirências',
                'Fechar',
                { duration: 5000, panelClass: ['mat-toolbar', 'warn'] }
              );
            }
          });
      }

    });


  }

  determinaQuantidadeParcelasCartao(cartao: any) {

    const tarifaMaiorParcela = cartao.contaCorrenteTerminalCartaoTarifas.length > 0 ? cartao.contaCorrenteTerminalCartaoTarifas.reduce((maior, atual) => {
      return atual.numeroParcelas >= maior.numeroParcelas ? atual : maior;
    }) : null;

    if(tarifaMaiorParcela == null) {
      this.quantidadeParcelasCartao = 1;

    } else{
      this.quantidadeParcelasCartao = tarifaMaiorParcela.numeroParcelas;
    }

    const parcelasSugeridas = this.IContaParcelaBaixa?.parcelasSugeridas;

    if (
      parcelasSugeridas != null &&
      parcelasSugeridas <= this.quantidadeParcelasCartao
    ) {
      this.contaParcelaBaixaForm
        .get('numeroParcelas')
        ?.setValue(parcelasSugeridas);
    }else{
      this.contaParcelaBaixaForm
        .get('numeroParcelas')
        ?.setValue(0);
    }

  }

}
